import React, { useEffect, useState, useCallback } from 'react';
import { VehicleView } from './VehicleGapDetection.types';

interface VanSVGProps {
  view: VehicleView;
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG sylwetki vana dla różnych widoków
 * Używa dynamicznego importu jak w SVGIcon
 */
export const VanSVG: React.FC<VanSVGProps> = ({ view, className = '', onLoad }) => {
  const [IconComponent, setIconComponent] = useState<React.FC<
    React.SVGProps<SVGSVGElement>
  > | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'van-strona-lewa';
      case 'top':
        return 'van-gora';
      case 'right':
        return 'van-strona-prawa';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error(`VanSVG: Błąd podczas importowania ${view}:`, error);
    }
  }, [view, getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent && onLoad) {
      onLoad();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
